
import React, { useState, useEffect } from 'react';
import './BlockCreationForGodown.css';
import Select from 'react-select';
import { getAllDistrictBihar, getDistrict, getStates } from '../../../services/monthlyAttendanceService';
import { getBlocksBasedOnsubId, getsubdivisionsBasedonDid, saveBlock, saveGodownLocation } from '../../../services/godownLatLongService';
import { capitalizeFirstLetter, isAlphabet, isDigit } from '../../../utils/validations';
import { useNavigate } from 'react-router-dom';


const BlockCreationForGodown = () => {
    const [districtOptions, setDistrictOptions] = useState([]);
    const [districtId, setDistrictId] = useState(null);
    const [subDivisionOptions, setSubDivisionOptions] = useState([]);
    const [subDivisionId, setSubDivisionId] = useState(null);
    const [state, setState] = useState(3);
    const [stateOptions, setStateOptions] = useState([]);

    const [blockUid, setBlockUid] = useState('');
    const [blockName, setBlockName] = useState('');
    const [latitude, setLatitude] = useState('');
    const [longitude, setLongitude] = useState('');
    // const [formData, setFormData] = useState({
    //   blockUid: '',
    //   blockName: '',
    //   latitude: '',
    //   longitude: ''
    // });
    const navigate = useNavigate();


    const godownTypeOptions = [
        { value: 'CMR', label: 'CMR' },
        { value: 'TPDS', label: 'TPDS' },

    ];
    useEffect(() => {
        const fetchStates = async () => {
            try {
                const res = await getStates();
                setStateOptions(res.map(item => ({
                    value: item.id,
                    label: capitalizeFirstLetter(item.stateName)
                })));
            } catch (err) {
                console.error('Error fetching states:', err);
            }
        };

        fetchStates();
    }, []);

    // Fetch Districts
    useEffect(() => {
        const fetchDistricts = async () => {
            if (state) {
                try {
                    const data = await getDistrict(state);
                    const formattedOptions = data.map(item => ({
                        value: item.districtId,
                        label: item.districtName,
                    }));
                    setDistrictOptions(formattedOptions);
                } catch (err) {
                    console.error('Error fetching districts:', err);
                }
            }
        };
        fetchDistricts();
    }, [state]);

    const fecthSubdivision = async (districtId) => {
        if (districtId) {

            try {
                const data = await getsubdivisionsBasedonDid(districtId);
                const formatedSub = data.map(sub => ({
                    value: sub.id,
                    label: capitalizeFirstLetter(sub.subDivisionName)
                }))
                setSubDivisionOptions(formatedSub);

            } catch (err) {
                console.error('Erro fetching Subdivison', err)
            }
        }

    }

    useEffect(() => {
        fecthSubdivision(districtId);
    }, [districtId])

    //   const fetchBlocks = async (subDivisionId) => {
    //     if (subDivisionId) {
    //       try {
    //         const data = await getBlocksBasedOnsubId(subDivisionId);
    //         const formatedBlock = data.map(blo => ({
    //           value: blo.id,
    //           label: capitalizeFirstLetter(blo.blockName)
    //         }))
    //         setBlocksOptions(formatedBlock);

    //       }
    //       catch (error) {
    //         console.log(error)
    //       }
    //     }
    //   }
    //   useEffect(() => {
    //     fetchBlocks(subDivisionId)
    //   }, [subDivisionId])


    const handleDistrictChange = (selectedOption) => {
        setDistrictId(selectedOption ? selectedOption.value : null);
    };

    const handleSubDivisionChange = (selectedOption) => {
        setSubDivisionId(selectedOption ? selectedOption.value : null);
    };
    const handleStateChange = (selectedOption) => {
        setState(selectedOption ? selectedOption.value : null);
        setSubDivisionId("");
        setDistrictId("");
    }



    const handleReset = () => {
        setDistrictId(null);
        setSubDivisionId(null);
        // setBlockId(null);
        // setGodownType(null);
        // setLatitude("");
        // setLongitude('');
        setBlockUid("");
        setState("");
        setBlockName('');
    };

    const handleSubmit = async () => {
        if (!blockUid || !blockName) {
            alert("Please fill all fields");
            return;
        }

        const payload = {
            blockUid,
            blockName,
            subDivisionId,
            //   latitude: parseFloat(latitude),
            //   longitude: parseFloat(longitude),
            //   godownType,
            //   block: {
            //     id: blockId
            //   },
            //   currentStatus: "ACTIVE"
        };

        try {
            await saveBlock(payload);
            alert("Block  saved successfully!");
            handleReset();
        } catch (error) {
            alert("Failed to save Block. Please try again.");
            console.error(error);
        }
    };
    const gotoCreationLatLong = () => {
        navigate("/UpdateBlock")
    }
    return (
        <div className="block-container">
            <div className="form-card">
                <h2 className="form-title">Create Block </h2>
                {/* <div className='navigate-btn'>
                    <button type='button' className='godown-btn-navigate' onClick={gotoCreationLatLong}>Back</button>
                </div> */}
                <div className="form-grid">
                    {/* Row 1 */}
                    <div className="input-group-block">
                        <Select
                            className={`custom-select ${state ? 'has-value' : ''}`}
                            classNamePrefix="select"
                            placeholder=" "
                            isClearable
                            options={stateOptions}
                            value={stateOptions.find(opt => opt.value === state) || null}
                            onChange={handleStateChange}
                        />
                        <label> <span className='reqiured'>*</span>State</label>
                    </div>

                    <div className="input-group-block">
                        <Select
                            className={`custom-select ${districtId ? 'has-value' : ''}`}
                            classNamePrefix="select"
                            placeholder=" "
                            isClearable
                            options={districtOptions}
                            value={districtOptions.find(opt => opt.value === districtId) || null}
                            onChange={handleDistrictChange}
                        />
                        <label> <span className='reqiured'>*</span>District</label>
                    </div>

                    <div className="input-group-block">
                        <Select
                            className={`custom-select ${subDivisionId ? 'has-value' : ''}`}
                            classNamePrefix="select"
                            placeholder=" "
                            isClearable
                            options={subDivisionOptions}
                            value={subDivisionOptions.find(opt => opt.value === subDivisionId) || null}
                            onChange={handleSubDivisionChange}
                        />
                        <label> <span className='reqiured'>*</span>Sub Division</label>
                    </div>


                    <div className="input-group-block">
                        <input
                            type="text"
                            className="custom-input"
                            placeholder=" "
                            name="blockUid"
                            value={blockUid}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (isDigit(value)) {
                                    setBlockUid(value);
                                }
                            }}
                        />
                        <label> <span className='reqiured'>*</span>Block UID</label>
                    </div>

                    <div className="input-group-block">
                        <input
                            type="text"
                            className="custom-input"
                            placeholder=" "
                            name="blockName"
                            value={blockName}
                            onChange={(e) =>{
                               const  value = e.target.value;
                                if (isAlphabet(value)) {
                                    setBlockName(value);
                                }
                                 }}
                        />
                        <label> <span className='reqiured'>*</span>Block Name</label>
                    </div>

                </div>

                <div className="button-group-lat">
                    <button className="btn btn-primary-lat" onClick={handleSubmit}>Save </button>
                    <button className="btn btn-secondary-lat" onClick={handleReset}>Clear</button>
                </div>
            </div>
        </div>
    );
};

export default BlockCreationForGodown;